export default __webpack_public_path__ + "static/media/Punto_04_Quartiere_Venezia_SPA_Def.246d1707.aac";